import axios from 'axios'
import Vue from 'vue'

const state = {
  groupsData: {},
}

const getters = {}

const mutations = {
  SET_STATUS_UPDATES(state, { groupId, data, page }) {
    if (!state.groupsData[groupId]) {
      Vue.set(state.groupsData, groupId, { page, statusUpdates: data })
    } else {
      const oldData = state.groupsData[groupId].statusUpdates
      Vue.set(state.groupsData, groupId, {
        page,
        statusUpdates: oldData.concat(data),
      })
    }
  },
}

const actions = {
  newChallenge,
  newMessage,
  fetchStatusUpdatesGroup,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function newChallenge({ commit, state, rootState }, { params }) {
  return axios.post(`/api/v1/challenge`, params).then((response) => {
    return response.data
  })
}

function newMessage({ commit, state, rootState }, params) {
  return axios
    .post(`/api/v1/challenge/new_message`, params)
    .then((response) => {
      return response.data
    })
}

function fetchStatusUpdatesGroup(
  { commit, state, rootState },
  { groupId, challengeId, pageNr }
) {
  if (!groupId || !challengeId) return
  let statePageNr = null
  if (pageNr) {
    commit('SET_STATUS_UPDATES', { groupId, page: pageNr, data: [] })
    statePageNr = pageNr
  } else {
    statePageNr =
      state.groupsData[groupId] && state.groupsData[groupId].page
        ? state.groupsData[groupId].page
        : 1
  }
  return axios
    .get(
      `/api/v1/group/${groupId}/status_updates/${statePageNr}/competition/${challengeId}`
    )
    .then((response) => {
      commit('SET_STATUS_UPDATES', {
        groupId: groupId,
        data: response.data,
        page: statePageNr + 1,
      })
      return response.data
    })
}
